module.exports = __webpack_public_path__ + "img/error-page.dfc368d9.png";